var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import api from "../../utils/api";
import { Translate } from "../../I18N";

import { PreserveIcon } from "../../Layout/PreserveIcon";
import { SettingsHeader } from "./SettingsHeader";
import "./styles/preserve.scss";

function mapStateToProps({ settings, user }) {
  return {
    settings: settings.collection,
    user
  };
}

const connector = connect(mapStateToProps);



const PreserveSettingsComp = ({ settings, user }) => {
  const [token, setToken] = useState('');
  const requestToken = async (e) => {
    e.preventDefault();
    const result = await api.post('preserve');
    setToken(result.json.token);
  };

  useEffect(() => {var _settings$get, _preserve$get;
    const preserve = (_settings$get = settings.get('features')) === null || _settings$get === void 0 ? void 0 : _settings$get.get('preserve');
    const userConfigs = preserve === null || preserve === void 0 ? void 0 : (_preserve$get = preserve.
    get('config')) === null || _preserve$get === void 0 ? void 0 : _preserve$get.
    find((conf) => {var _conf$get, _user$get;return (conf === null || conf === void 0 ? void 0 : (_conf$get = conf.get('user')) === null || _conf$get === void 0 ? void 0 : _conf$get.toString()) === ((_user$get = user.get('_id')) === null || _user$get === void 0 ? void 0 : _user$get.toString());});

    if (userConfigs) {
      const savedToken = userConfigs.get('token');
      setToken(savedToken);
    }
  }, []);

  return (/*#__PURE__*/
    _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "panel panel-preserve panel-default" }, void 0, /*#__PURE__*/
    _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "panel-preserve-heading" }, void 0, /*#__PURE__*/
    _jsx(PreserveIcon, { color: "#D20D6C" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Preserve Extension")
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "panel-preserve-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "status" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "You have not connected an Uwazi instance, yet")
    ), /*#__PURE__*/
    _jsx("div", { className: "setup" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "span" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "INSTALL the browser extension")
    ), /*#__PURE__*/
    _jsx("br", {}), /*#__PURE__*/
    _jsx("div", { className: "span" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Preserve Setup Description" }, void 0, "If you know your Uwazi URL and TOKEN click the link below, and fill the required information."


    )
    ), /*#__PURE__*/
    _jsx("div", { className: "install-buttons", style: { display: 'none' } }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Install browser extension (dynamic link)")
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("a", {
      href: "https://uwazi.io/page/9852italrtk/support",
      target: "_blank",
      rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Chrome extension store link")
    )
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("a", {
      href: "https://uwazi.io/page/9852italrtk/support",
      target: "_blank",
      rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Firefox extension store link")
    )
    )
    ), /*#__PURE__*/
    _jsx("hr", {}), /*#__PURE__*/
    _jsx("div", { className: "preserve-token" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Configuration")
    ), /*#__PURE__*/
    _jsx("form", { onSubmit: requestToken }, void 0, /*#__PURE__*/
    _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
    _jsx("label", { className: "form-group-label", htmlFor: "collection_name" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Extension Token")
    ), /*#__PURE__*/
    _jsx("input", { value: token, className: "form-control", disabled: true })
    ),
    token && /*#__PURE__*/
    _jsx("button", {
      className: "btn btn-success",
      type: "button",
      onClick: async () => {
        await navigator.clipboard.writeText(token);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Copy token")
    ),

    !token && /*#__PURE__*/
    _jsx("button", { type: "submit", className: "btn btn-success" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Request token")
    )

    )
    )
    )
    )
    )
    ));

};
const container = connector(PreserveSettingsComp);
export { container as PreserveSettings };